<div class="callFloatter">
    <a (click)="callNow()">
    <span><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/CALL.svg"  width="30"> Call us</span>
    </a>
</div>